//case study scroller
(function () {
    window.gbg = window.gbg || {};
    gbg.FeatureSlider = (function () {

        const slider = document.querySelector('.featureslider-container');
        const sliderItems = document.querySelectorAll('.featureslider__item');

        const Init = function () {

            if (!slider || window.innerWidth < 992) return;

            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    entry.target.classList.add('featureslider__item--slide');
                    if (entry.isIntersecting) {
                        entry.target.classList.add('featureslider__item--vis');
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                rootMargin: '-30%'
            });

            sliderItems.forEach(item => {
                observer.observe(item)
            });

        };

        return {
            Init: Init
        };
    }());

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", gbg.FeatureSlider.Init);
    } else {
        gbg.FeatureSlider.Init();
    }

    //window.addEventListener('load', function () {
    //    gbg.FeatureSlider.Init();

    //});
})();